import Navbar from "./Navbar";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useEffect, useState, useRef } from "react";
import Footer from "./Footer";
import { getBaseUrl } from "../utils";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const Home = () => {
    const token = localStorage.getItem("userToken");
    const navigate = useNavigate();

    const PrevArrow = ({ onClick }) => {
        return (
            <button
                className="slick-prev"
                onClick={onClick}
                style={{ zIndex: 10 }}
            >
                <i
                    className="fa fa-angle-left"
                    style={{ fontSize: "24px", color: "#000" }}
                ></i>
            </button>
        );
    };

    const NextArrow = ({ onClick }) => {
        return (
            <button
                className="slick-next"
                onClick={onClick}
                style={{ zIndex: 9999 }}
            >
                <i
                    className="fa fa-angle-right"
                    style={{ fontSize: "24px", color: "#000" }}
                ></i>
                fhsdgsdh
            </button>
        );
    };

    const settings = {
        centerMode: true,
        centerPadding: "202px",
        slidesToShow: 2,
        arrows: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 3000,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    centerMode: true,
                    centerPadding: "30px",
                },
            },
            {
                breakpoint: 580,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "20px",
                },
            },
        ],
    };



    const [activeIndex, setActiveIndex] = useState(null);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index); // Toggle FAQ
    };


    // State definitions
    const [bannerWeb, setBannerWeb] = useState([]);
    const [latestBlog, setLatestBlog] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [latestTest, setLatestTest] = useState([]);
    const [testCategoryData, setTestCategoryData] = useState([]);
    const [studyMaterialData, setStudyMaterialData] = useState([]);
    const [expertMentors, setExpertMentors] = useState([]);
    const [getCategoryListWithSubjects, setgetCategoryListWithSubjects] = useState([]);
    const [faqData, setfaqData] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // Effect to fetch data
    async function gethomeData() {
        const baseUrl = getBaseUrl();
        const response = await axios.get(`${baseUrl}user_api/homeDataWeb`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const data = response.data;

        console.log("Home ========> ", data);

        setBannerWeb(data.bannerWeb || []);
        setLatestBlog(data.latestBlog || []);
        setTestimonials(data.testimonls || []);
        setLatestTest(data.latestTest || []);
        setTestCategoryData(data.testCategoryData || []);
        setStudyMaterialData(data.studyMaterialData || []);
        setExpertMentors(data.expertMentors || []);
        setgetCategoryListWithSubjects(data.getCategoryListWithSubjects || []);
        setfaqData(data.faqData || []);
    }

    useEffect(() => {
        gethomeData();
    }, []);
    // bolg slider section main

    const imageData = [
        {
            src: "/assates/Blog__images__slider.png",
            title: "What is Study?",
            description:
                "Lorem Ipsum is simply dummy text for printing and typesetting industry.",
            uploadedDate: "30 Dec, 2024",
        },
        {
            src: "/assates/Blog__images__slider.png",
            title: "The Power of Education",
            description:
                "Lorem Ipsum is simply dummy text for printing and typesetting industry.",
            uploadedDate: "15 Jan, 2025",
        },
        {
            src: "/assates/Blog__images__slider.png",
            title: "Learning is Fun",
            description:
                "Lorem Ipsum is simply dummy text for printing and typesetting industry.",
            uploadedDate: "10 Feb, 2025",
        },
        {
            src: "/assates/Blog__images__slider.png",
            title: "Learning is Fun",
            description:
                "Lorem Ipsum is simply dummy text for printing and typesetting industry.",
            uploadedDate: "10 Feb, 2025",
        },
    ];

    const settings__new = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    // testimonil section slider coding start
    const testimonialsData = [
        {
            name: "Zen",
            role: "Author",
            text: "Zen Daan is a businessZen Daan Zen Daan is a businessZen DaanZen Daan is a businessZen DaanZen Daan is a businessZen Daan is a businessZen Daan is a businessZen Daan is a businessZen Daan is a business analyst, entrepreneur and media proprietor, and investor. She is also known as the best",
            image: "https://user-images.githubusercontent.com/13468728/234031693-6bbaba7d-632c-4d7d-965f-75a76a549ce2.jpg" // Replace with actual image URL
        },
        {
            name: "John Doe",
            role: "CEO",
            text: "Zen Daan is a businessZen Daan Zen Daan is a businessZen DaanZen Daan is a businessZen DaanZen Daan is a businessZen Daan is a businessZen Daan is a businessZen Daan is a businessZen Daan is a business analyst, entrepreneur and media proprietor, and investor. She is also known as the best",
            image: "https://user-images.githubusercontent.com/13468728/234031693-6bbaba7d-632c-4d7d-965f-75a76a549ce2.jpg"
        },
        {
            name: "Jane Smith",
            role: "Marketing Head",
            text: "Zen Daan is a businessZen Daan Zen Daan is a businessZen DaanZen Daan is a businessZen DaanZen Daan is a businessZen Daan is a businessZen Daan is a businessZen Daan is a businessZen Daan is a business analyst, entrepreneur and media proprietor, and investor. She is also known as the best",
            image: "https://user-images.githubusercontent.com/13468728/234031693-6bbaba7d-632c-4d7d-965f-75a76a549ce2.jpg"
        }
    ];
    const sliderSettings__new__data = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
    };

    const sliderSettings__banner__new = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000
    };

    const [currentIndex, setCurrentIndex] = useState(0);
    const slideRowRef = useRef(null);
    const mainRef = useRef(null);

    const updateSlide = () => {
        if (slideRowRef.current && mainRef.current) {
            const mainWidth = mainRef.current.offsetWidth;
            slideRowRef.current.style.transform = `translateX(${currentIndex * -mainWidth}px)`;
        }
    };

    useEffect(() => {
        updateSlide();
        window.addEventListener("resize", updateSlide);
        return () => window.removeEventListener("resize", updateSlide);
    }, [currentIndex]);

    const handleTabClick = (blogData) => {
        navigate(token ? "/BlogDeatils" : "/login", { state: { blogData: blogData } });
    };

    return (
        <div>
            <Navbar />
            <section className="bg-[#28282B] mt-20 overflow-hidden">
                <div className="container-xxl pt-[90px] pb-[20px]">
                    <div className="row">
                        <div className="col-12 col-md-5 p-0 m-0 text-white px-4 sm:px-0">
                            <div className="Header__text">
                                <h1 className="font-bold text-4xl pb-2">

                                    अपनी क्षमता को पहचानें.
                                    हमारे साथ ..

                                </h1>
                                <div className="flex items-center gap-3 pt-2 pb-4">
                                    <div className="text-2xl font-semibold">
                                        Learn Today,
                                    </div>
                                    <div>
                                        <img
                                            src="/assates/Home__images.svg"
                                            alt="Home images"
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div>
                                        <img
                                            src="/assates/Home_secound_images.svg"
                                            alt="Home images"
                                        />
                                    </div>
                                    <div className="text-2xl font-semibold">
                                        Lead Tomorrow
                                    </div>
                                </div>
                                <p className="font-semibold pt-6 pb-6 text-lg">
                                    करियर में अनावश्यक स्ट्रगल से सावधान रहें. हम आपके लिए एक सही करियर रोडमैप तैयार करेंगे.

                                </p>
                            </div>
                            <button
                                onClick={() => {
                                    navigate(token ? "/dashboard" : "/login");
                                }}
                                className="w-[180px] Paragraph__etxt h-[48px]  rounded-[15px] text-[18px] font-[600] bg-[#FFFFFF] text-[#28282B] hover:border border-black hover:bg-transparent hover:text-[#28282B] ease-in-out">
                                Get Started
                            </button>
                        </div>

                        <div className="col-12 col-md-2 p-0 m-0 ">
                            <img
                                src="/assates/hOME_TESTIMONIAKL.svg"
                                alt="Home images"
                                className="w-full object-cover lg:block hidden mt-12"
                            />
                        </div>

                        <div className="col-md-5 p-0 m-0 sm:px-0">
                            <img
                                src="/assates/Guru_Home.png"
                                alt="images"
                                className="mt-12 sm:mt-0 pr-8 md:pr-0 w-full object-cover rounded-lg"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="Timer__Section bg-white overflow-hidden">
                <div className="container-xxl pt-[45px] pb-[45px]">
                    <div className="row  sm:pl-[100px] sm:pr-[100px] px-4">
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-6 flex items-start justify-start  flex-col">
                                    <div className="flex items-center flex-col">
                                        <h1 className="timer__section font-[800] text-[24px]">
                                            250M+
                                        </h1>
                                        <label className="timer__section font-[500] text-[24px]">
                                            Students
                                        </label>
                                    </div>
                                </div>
                                <div className="col-6 md:text-center text-right">
                                    <h1 className="timer__section font-[800] text-[24px]">
                                        30000+
                                    </h1>
                                    <label className="timer__section font-[500] text-[24px]">
                                        Colleges
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-6 md:text-center text-left md:pl-14 pl-4 sm:mt-0 mt-16">
                                    <h1 className="timer__section font-[800] text-[24px]">
                                        500+
                                    </h1>
                                    <label className="timer__section font-[500] text-[24px]">
                                        Exams
                                    </label>
                                </div>
                                <div className="col-6 flex items-end justify-end  flex-col">
                                    <div className="flex items-center flex-col">
                                        <h1 className="timer__section font-[800] text-[24px]">
                                            250M+
                                        </h1>
                                        <label className="timer__section font-[500] text-[24px]">
                                            Students
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-[#F2F2F2] pt-[90px] pb-[90px] overflow-hidden" id="career-section">
                <div className="container-xxl">
                    <div className="row">
                        <div className="header_section flex sm:items-center items-start justify-center flex-col">
                            <h1 className="Header__text sm:text-center text-left font-[700] text-[42px]">
                                Choose Qualification
                            </h1>
                            <p className="Paragraph__etxt sm:text-center text-left font-[500] pb-[30px]">
                                Choose the qualification that aligns with your
                                goals and sets you on the path to success.{" "}
                                <br></br>
                                Explore options tailored to your career and
                                personal growth aspirations.
                            </p>
                        </div>
                        <div className="col-md-6 p-[10px]">
                            <div className="items-center bg-[#FFFFFF] p-[30px] rounded-[15px] choose_qulifation_section">
                                <div className="flex justify-between">
                                    <div>
                                        <button onClick={() => { navigate(token ? "/dashboard" : "/login"); }} className="h-[70px] w-[70px] text-[25px] bg-black rounded-full text-white mt-12">
                                            <i className="ri-arrow-right-up-line"></i>
                                        </button>
                                        <h5
                                            className="pt-[40px] Header__text font-[700]"
                                            style={{ fontSize: "28px" }}
                                        >
                                            {testCategoryData[0] ? testCategoryData[0].name : ""}
                                        </h5>
                                    </div>
                                    <div>
                                        <img
                                            src={testCategoryData[0] ? testCategoryData[0].image : ""}
                                            // src="/assates/Education__One.jpg"
                                            alt="images"
                                            className="w-[240px] rounded-lg"
                                        />


                                    </div>
                                </div>
                                <div>
                                    <div className="Paragraph__etxt text-[#28282B]">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: testCategoryData[0] ? testCategoryData[0].description : "",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 p-[10px]">
                            <div className="items-center bg-[#FFFFFF] p-[30px] rounded-[15px] choose_qulifation_section">
                                <div className="">
                                    <div className="w-full">
                                        <h5
                                            className="pt-[10px] Header__text font-[700]"
                                            style={{ fontSize: "28px" }}
                                        >
                                            {testCategoryData[1] ? testCategoryData[1].name : ""}
                                        </h5>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: testCategoryData[1] ? testCategoryData[1].description : "",
                                            }}
                                        />


                                    </div>
                                    <div className="flex justify-between">
                                        <button onClick={() => { navigate(token ? "/dashboard" : "/login"); }} className="h-[70px] w-[70px] text-[25px] bg-black rounded-full text-white mt-12">
                                            <i className="ri-arrow-right-up-line"></i>
                                        </button>
                                        <img
                                            src={testCategoryData[1] ? testCategoryData[1].image : ""}
                                            alt="images"
                                            className="rounded-lg h-[160px] w-[220px]"
                                        />


                                    </div>
                                </div>
                                <div>
                                    <div className="Paragraph__etxt">

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-6 p-[10px]">
                            <div className="items-center bg-[#FFFFFF] p-[30px] rounded-[15px] choose_qulifation_section">
                                <div className="">
                                    <div className="w-full">
                                        <h5
                                            className="pt-[10px] Header__text font-[700]"
                                            style={{ fontSize: "28px" }}
                                        >
                                            {testCategoryData[2] ? testCategoryData[2].name : ""}
                                        </h5>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: testCategoryData[2] ? testCategoryData[2].description : "",
                                            }}
                                        />


                                    </div>
                                    <div className="flex justify-between">
                                        <button onClick={() => { navigate(token ? "/dashboard" : "/login"); }} className="h-[70px] w-[70px] text-[25px] bg-black rounded-full text-white mt-12">
                                            <i className="ri-arrow-right-up-line"></i>
                                        </button>
                                        <img
                                            src={testCategoryData[2] ? testCategoryData[2].image : ""}
                                            alt="images"
                                            className="rounded-lg h-[160px] w-[220px]"
                                        />


                                    </div>
                                </div>
                                <div>
                                    <div className="Paragraph__etxt">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 p-[10px]">
                            <div className="items-center bg-[#FFFFFF] p-[30px] rounded-[15px] choose_qulifation_section">
                                <div className="flex justify-between">
                                    <div>
                                        <button onClick={() => { navigate(token ? "/dashboard" : "/login"); }} className="h-[70px] w-[70px] text-[25px] bg-black rounded-full text-white mt-12">
                                            <i className="ri-arrow-right-up-line"></i>
                                        </button>
                                        <h5
                                            className="pt-[40px] Header__text font-[700]"
                                            style={{ fontSize: "28px" }}
                                        >
                                            {testCategoryData[3] ? testCategoryData[3].name : ""}
                                        </h5>
                                    </div>
                                    <div>
                                        <img
                                            src={testCategoryData[3] ? testCategoryData[3].image : ""}
                                            // src="/assates/Education__four.jpg"
                                            alt="images"
                                            className="w-[240px] rounded-lg"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="Paragraph__etxt text-[#28282B]">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: testCategoryData[3] ? testCategoryData[3].description : "",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-[60px]  pb-[60px] overflow-hidden">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-12 p-[10px] m-0">
                            <div className="testimonial-wrapper">

                                <Slider {...sliderSettings__banner__new}>
                                    {bannerWeb.map((item, index) => (
                                        <img key={index} src={item.img} alt="image" className="rounded-lg" />
                                    ))}
                                </Slider>
                            </div>


                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-[100px] pb-[100px] bg-[#F2F2F2] overflow-hidden">
                <div className="container-xxl">
                    <div className="row">
                        <div className="header_section flex sm:items-center items-start justify-center flex-col">
                            <h1 className="Header__text font-[700] text-[42px]">
                                Study Materials
                            </h1>
                            <p className="Paragraph__etxt sm:text-center text-left font-[500] pb-[30px]">
                                Choose the qualification that aligns with your
                                goals and sets you on the path to success.
                                <br></br>
                                Explore options tailored to your career and
                                personal growth aspirations.
                            </p>
                        </div>
                        {studyMaterialData.map((data) => (
                            <div className="col-md-4 p-0 m-0 ">
                                <div className="p-[15px]">
                                    <div className="p-[10px]  bg-[#FFFFFF] choose_qulifation_section rounded-[15px]">
                                        <div

                                            onClick={() => {
  console.log("Token:", token);
  console.log("Navigating to:", token ? "/dashboard/myMaterials" : "/login");
  console.log("subjectData:", data.subjectData._id);

      localStorage.setItem("selectedSubject", data.subjectData._id);


  navigate(token ? "/dashboard/myMaterials" : "/login");
}}

                                            className="text-[#28282B] Header__text font-[700] ml-1 mb-2"
                                            style={{ fontSize: "18px" }}
                                        >
                                            See {data.fileType}
                                            <i className="ri-arrow-right-line"></i>
                                        </div>

                                        <div>
                                            <img
                                                src={data.image}
                                                alt="images"
                                                className="rounded-lg"
                                            />
                                        </div>
                                        <div className="">
                                            <h5
                                                className="Header__text font-[700] pt-[15px] pb-[5px]"
                                                style={{ fontSize: "18px" }}
                                            >
                                                {data.name}
                                            </h5>
                                            <div className="Paragraph__etxt text-[#818181] pb-[10px]">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: data.description,
                                                    }}
                                                />
                                            </div>
                                            <button
                                                className="Header__text bg-[#28282B1A] pl-[20px] pt-[10px] pr-[20px] pb-[10px] rounded-full"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {data.subjectData.name}
                                            </button>
                                        </div>
                                        <div className="flex justify-between p-1 pt-3 pb-2 items-center8">
                                            <div
                                                className="Paragraph__etxt text-[#818181]"
                                                style={{ fontSize: "14px" }}
                                            >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <h1 className="Paragraph__etxt text-center">See all</h1>
                    </div>
                </div>
            </section>

           <section className="overflow-hidden py-12 bg-white">
    <div className="container-fluid">
        <div className="row">
            {/* Heading */}
            <div className="header_section flex items-center justify-center flex-col mb-8">
                <h1 className="Header__text font-bold text-3xl md:text-[42px] text-center">
                    Expert Mentors
                </h1>

                <p className="Paragraph__etxt text-center font-medium mt-3">
                    Choose the qualification that aligns with your goals and sets
                    you on the path to success.
                    <br className="hidden md:block" />
                    Explore options tailored to your career and personal growth
                    aspirations.
                </p>
            </div>

            <div className="col-12">
                <div className="slider-container">
                    <Slider {...settings}>
                        {expertMentors.map((data, index) => (
                            <div key={index} className="p-2 md:p-3">

                                {/* Card */}
                                <div className="bg-[#F2F2F2] rounded-2xl p-4 shadow-sm hover:shadow-lg transition-all duration-300 h-[300px] md:h-[310px] flex flex-col">

                                    {/* Rating */}
                                    <div className="flex justify-end items-center gap-1 mb-3">
                                        <img
                                            src="/assates/star__iocns.svg"
                                            alt="star"
                                            className="w-3 h-3"
                                        />
                                        <span className="text-sm font-medium">
                                            {data.avgRating || 0}
                                        </span>
                                    </div>

                                    {/* Mentor Details */}
                                    <div className="flex gap-4 flex-1 overflow-hidden border-b pb-4">

                                        {/* Image */}
                                        <div className="flex-shrink-0">
                                            <img
                                                src={data.profile_img}
                                                alt={data.name}
                                                className="w-20 h-20 md:w-24 md:h-24 rounded-xl object-cover border"
                                            />
                                        </div>

                                        {/* Content */}
                                        <div className="flex flex-col flex-1 overflow-hidden">

                                            <h5 className="font-bold text-lg md:text-xl text-[#28282B] mb-2 truncate">
                                                {data.name}
                                            </h5>

                                            <p className="text-sm font-medium text-gray-800">
                                                <span className="font-semibold">
                                                    Expertise:
                                                </span>
                                            </p>

                                           <p
    className="text-sm text-gray-700 leading-6 break-words"
    style={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
    }}
>
    {(data.subjects || "").replaceAll(",", ", ")}
</p>

                                            <p className="text-sm text-gray-700 mt-3">
                                                {data.experience} Years of Experience
                                            </p>

                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="flex justify-center items-center pt-4 mt-auto">

                                        <button
                                            onClick={() => {
                                                navigate(
                                                    token
                                                        ? "/counselling"
                                                        : "/login"
                                                );
                                            }}
                                            className="bg-black text-white px-8 py-2 rounded-lg hover:bg-gray-800 transition-all duration-300 font-semibold"
                                        >
                                            Book Now
                                        </button>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    </div>
</section>

           <section className="overflow-hidden pt-[100px] pb-[100px] bg-[#F2F2F2]">
                <div className="container-xxl">
                    <div className="row">
                        <div className="header_section flex sm:items-center items-start justify-center flex-col">
                            <h1 className="Header__text font-[700] text-[42px]">
                                Our Blogs
                            </h1>
                            <p className="Paragraph__etxt sm:text-center text-left font-[500] pb-[30px]">
                                Explore our blogs for insights, tips, and updates on a wide range of <br></br> topics. Stay informed and
                                inspired with expert-driven content tailored for you.
                            </p>
                        </div>

                        <div className="col-12 p-0 m-0">
    <Slider {...settings__new}>
        {latestBlog.map((item, index) => (
            <div key={index} className="px-2 py-3">
                <div
                    onClick={() => handleTabClick(item)}
                    className="cursor-pointer bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 h-[200px] md:h-[190px]"
                >
                    <div className="flex flex-col sm:flex-row h-full">

                        {/* Image */}
                        <div className="w-full sm:w-[40%] h-[180px] sm:h-full overflow-hidden rounded-t-2xl sm:rounded-l-2xl sm:rounded-tr-none">
                            <img
                                src={item.image}
                                alt={item.name}
                                className="w-full h-full object-cover transition-all duration-300 hover:scale-105"
                            />
                        </div>

                        {/* Content */}
                        <div className="w-full sm:w-[60%] p-3 flex flex-col justify-between">

                            <div>

                                {/* Title */}
                                <h4
                                    className="Paragraph__etxt font-bold text-base md:text-lg leading-6"
                                    style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    }}
                                >
                                    {item.name}
                                </h4>

                                {/* Description */}
                                <div
                                    className="Paragraph__etxt text-sm text-gray-600 mt-2 leading-6"
                                    style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description,
                                    }}
                                />

                            </div>

                            {/* Date */}
                            <div className="mt-3">
                                <label className="Paragraph__etxt text-xs text-gray-500">
                                    Uploaded on
                                </label>

                                <br />

                                <label className="Paragraph__etxt font-bold text-xs md:text-sm">
                                    {item.Created_date}
                                </label>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        ))}
    </Slider>
</div>




                    </div>
                </div>
            </section >
 

            <section className="Make_Resume pt-[70px] pb-[40px] overflow-hidden">
                <div className="container-xxl">
                    <div className="row flex items-center">
                        <div className="col-md-7">
                            <h1 className="Header__text text-white font-[700] pb-2">
                                हमारे साथ मिलकर एक बेहतरीन रिज़्यूमे तैयार करें
                            </h1>
                            <p
                                className="Paragraph__etxt text-white font-[300] pb-4"
                                style={{ lineHeight: "30px" }}
                            >
                                आपकी शुरुआत हमेशा शानदार होनी चाहिए। आपके स्किल और अचीवमेंट को एक प्रभावशाली Resume / CV शोकेस कर सकता है।
                                तो बनाएं, अपना प्रोफेशनल Resume / CV निःशुल्क और पायें इसे पीडीएफ फॉर्मेट में अपने ब्राउज़र और फोन पर।
                                ताकि एक अच्छे परिचय से हो आपकी शानदार शुरुआत।
                            </p>
                            <button onClick={() => { navigate(token ? "/dashboard" : "/login"); }} className="w-[180px] Paragraph__etxt h-[48px]  rounded-[15px] text-[18px] font-[600] bg-[#FFFFFF] text-[#28282B] hover:border border-black hover:bg-transparent hover:text-[#28282B] ease-in-out">
                                Get Started
                            </button>
                        </div>
                        <div className="col-md-5">
                            <img src="/assates/make__resume.png" alt="images" className="w-full " />
                        </div>
                    </div>
                </div>
            </section>


            <section className="testimonial__section overflow-hidden pt-[50px] pb-[50px] bg-white">
                <div className="container-xxl">
                    <div className="row">
                        <div className="header_section flex sm:items-center items-start justify-center flex-col">
                            <h1 className="Header__text font-[700] text-[42px]">
                                Student Testimonials
                            </h1>
                            <p className="Paragraph__etxt sm:text-center text-left font-[500] pb-[30px]">
                                Explore our blogs for insights, tips, and updates on a wide range of <br></br> topics. Stay informed and
                                inspired with expert-driven content tailored for you.
                            </p>
                        </div>

                        {/* {false && (
                            <div className="col-12 p-0 m-0">
                                <div className="testimonial-wrapper">
                                    <Slider {...sliderSettings__new__data}>
                                        {testimonials.map((item, index) => (
                                            console.log(item.text),
                                            <div className="p-2 flex items-center justify-center" key={index}>
                                                <div className="w-full">
                                                    <div className="w-full sm:flex relative">
                                                        <div className="text___section_main w-full p-4">
                                                            <div className="sm:absolute Text___testimonil__section mt-[30px] rounded-xl z-[2000]">

                                                                <p className="pb-2 Paragraph__etxt" style={{ fontSize: '16px' }}>{item.feedback}</p>
                                                                <div className="flex items-start flex-col ">
                                                                    <label className="pb-1 Header__text" style={{ padding: '0', margin: '0' }}>{item.user_name}</label>
                                                                    <label className="Paragraph__etxt" style={{ fontSize: '15px' }}>Author</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="images p-3 rounded-xl images__section__testmonial">
                                                            <div className="images__section__testmonial">
                                                                <img src={item.img} alt="images" className="w-[300px] rounded-xl" />

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        )} */}


                       <div className="col-12 p-0 m-0">
    <div className="testimonial-wrapper">

        <Slider {...sliderSettings__new__data}>
            {testimonials.map((item, index) => (
                <div className="p-2" key={index}>
                    <div className="w-full">

                        <div className="row bg-white shadow rounded-4 overflow-hidden min-h-[220px] md:min-h-[260px]">

                            {/* Text Section */}
                            <div className="col-12 col-md-9 p-4 d-flex flex-column justify-content-center order-2 order-md-1">

                                <div className="Text___testimonil__section">

                                    <p
                                        className="Paragraph__etxt text-[15px] md:text-[16px] leading-7 mb-3"
                                        style={{
                                            display: "-webkit-box",
                                            WebkitLineClamp: 5,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {item.feedback}
                                    </p>

                                    <div className="flex flex-col">
                                        <label
                                            className="Header__text font-bold text-[18px]"
                                        >
                                            {item.user_name}
                                        </label>

                                        <label className="Paragraph__etxt text-gray-500 text-sm">
                                            Student
                                        </label>
                                    </div>

                                </div>

                            </div>

                            {/* Image Section */}
                            <div className="col-12 col-md-3 p-3 d-flex align-items-center justify-content-center order-1 order-md-2">

                                <div className="w-full h-[220px] sm:h-[260px] md:h-[220px] lg:h-[260px] overflow-hidden rounded-3">

                                    <img
                                        src={item.img}
                                        alt={item.user_name}
                                        className="w-full h-full object-cover rounded-3 transition-all duration-300 hover:scale-105"
                                    />

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            ))}
        </Slider>

    </div>
</div>


                    </div>
                </div>
            </section>



            <section className="faq-section py-10 sm:px-5 px-2 bg-gray-100">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-12">
                            <div className="header_section flex sm:items-center items-start justify-center flex-col">
                                <h1 className="Header__text font-[700] text-[42px]">
                                    Frequently Asked Questions
                                </h1>
                                <p className="Paragraph__etxt sm:text-center text-left font-[500] pb-[30px]">
                                    Choose the qualification that aligns with
                                    your goals and sets you on the path to
                                    success. <br></br>
                                    Explore options tailored to your career and
                                    personal growth aspirations.
                                </p>
                            </div>
                            <div className="faq-container space-y-4">
                                {faqData.map((item, index) => (
                                    <div
                                        key={index}
                                        className="faq-item bg-white shadow-sm rounded overflow-hidden "
                                    >
                                        <div
                                            className="faq-question flex justify-between items-center p-4 cursor-pointer "
                                            onClick={() => toggleFaq(index)}
                                        >
                                            <h3 className="Paragraph__etxt font-[700]">
                                                {item.question}
                                            </h3>
                                            <span>
                                                {activeIndex === index ? (
                                                    <i className="ri-subtract-fill border rounded-full p-1"></i>
                                                ) : (
                                                    <i className="ri-add-large-line  border rounded-full p-1"></i>
                                                )}
                                            </span>
                                        </div>
                                        {activeIndex === index && (
                                            <div className="faq-answer p-4 text-gray-600 Paragraph__etxt">
                                                {item.ans}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div >
    );
};

export default Home;
